import React, { ReactNode } from 'react';
import Button, { ButtonType } from '../button/Button';
import styles from './EmptyState.module.scss';

interface EmptyStateProps {
  icon?: ReactNode;
  title?: string;
  description?: string;
  button?: {
    text: string;
    onClick: () => void;
    type?: ButtonType;
  };
  className?: string;
}

const EmptyState: React.FC<EmptyStateProps> = ({
  icon,
  title,
  description,
  button,
  className = '',
}) => {
  return (
    <div className={`${styles.emptyState} ${className}`}>
      <div className={styles.content}>
        {icon && <div className={styles.iconContainer}>{icon}</div>}
        
        {title && <h3 className={styles.title}>{title}</h3>}
        
        {description && <p className={styles.description}>{description}</p>}
        
        {button && (
          <div className={styles.buttonContainer}>
            <Button
              text={button.text}
              onClick={button.onClick}
              variant={button.type ?? 'primary'}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default EmptyState;